module.exports = __webpack_public_path__ + "static/img_6664_optimized-853de122fb2f7eaa1d2305e730d0dcd0.jpg";